import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { Navigation, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { RouteService } from 'src/app/services/route.service';
import { Route } from 'src/app/_models/view/route';
import { BsModalService } from 'ngx-bootstrap/modal';
import { OpenRouteComponent } from './saved-route/open-route.component';
import { Trip } from 'src/app/_models/daws/trip';
import { RoutingProfileService } from 'src/app/services/vehicle-routing-profile.service';
import { SubscriptionManager } from 'src/app/_helpers/subscription-manager';
import { BrazeService } from 'src/app/services/braze.service';
import { map } from 'rxjs/operators';
import { GoogleAnalytics } from 'src/app/services/google-analytics.service';
import { AlertService } from 'src/app/auth/services/alert.service';
import { OpenLegacyRouteComponent } from './saved-route/open-legacy-route.component';
import { createModalOptions } from 'src/app/_helpers/create-modal-options';
import { ModalboxComponent } from '../modalbox/modalbox.component';

@Component({
  selector: 'app-route-panel',
  templateUrl: './route-panel.component.html',
  styles: [],
})
export class RoutePanelComponent implements OnInit, OnDestroy {
  @HostBinding('class') cssClass = 'modus-panel panel-xl shadow';
  subscriptionManager = new SubscriptionManager();
  profilesLoaded$: Observable<boolean>;
  routes$: Observable<Route[]>;
  navigation: Navigation;
  isRoutePanelEmpty$: Observable<boolean>;
  constructor(
    private brazeService: BrazeService,
    private profileService: RoutingProfileService,
    private router: Router,
    private routeService: RouteService,
    private modalService: BsModalService,
    private googleAnalytics: GoogleAnalytics,
    private alertService: AlertService
  ) {
    this.navigation = this.router.getCurrentNavigation();
    this.profilesLoaded$ = this.profileService.profilesLoaded$;
  }

  bsConfig = {
    containerClass: 'theme-dark-blue',
    showWeekNumbers: false,
  };

  ngOnInit(): void {
    this.routes$ = this.routeService.routes$;
    this.subscriptionManager.manage =
      this.profileService.retrieveAllProfilesSubscrition();
    this.subscriptionManager.manage = this.routes$.subscribe((routes) => {
      if (routes.length === 0) {
        this.newRoute();
      }
    });
    this.isRoutePanelEmpty$ = this.routes$.pipe(
      map((routes) => routes.length <= 1)
    );
  }

  ngOnDestroy(): void {
    this.subscriptionManager.unsubscribe();
  }

  newRoute() {
    this.routeService.newRouteFromDefaults();
    this.googleAnalytics.addGA(
      'New_Route',
      'New_Route_Click',
      'Route',
      'Clicks New Route'
    );
    this.alertService.clear();
  }

  // deleteAllRoutes() {
  //   this.googleAnalytics.addGA(
  //     'Delete_All_Routes',
  //     'Delete_All_Routes_Click',
  //     'Route',
  //     'Clicks Delete All Routes Routes'
  //   );
  //   const initialState = {
  //     title: 'Delete Route',
  //     list: ['Are you sure you want to delete all routes?'],
  //     actionButtonText: 'Delete',
  //     btnClass: 'btn btn-danger',
  //   };
  //   const dialogRef = this.modalService.show(ModalboxComponent, {
  //     initialState,
  //     ignoreBackdropClick: true,
  //     keyboard: false,
  //     animated: true,
  //     class: 'modal-dialog-centered',
  //   });

  //   this.subscriptionManager.manage = dialogRef.content.event.subscribe(() => {
  //     this.routeService.deleteAllRoutes();
  //     this.alertService.clear();
  //   });
  // }

  defaultRouteOptions() {
    console.warn('Implement defaultRouteOptions');
  }
  showSavedRoute() {
    this.brazeService.track('Clicks Open Saved Route');
    this.googleAnalytics.addGA(
      'Open_Saved_Route',
      'Open_Saved_Route_Click',
      'Route',
      'Clicks Open Saved Route'
    );
    const modalRef = this.modalService.show(OpenRouteComponent, {
      class: 'modal-lg',
      backdrop: 'static',
    });
    this.subscriptionManager.manage = modalRef.content.showRouteEvent.subscribe(
      (data: Trip) => {
        const availableProfileId = this.profileService.getProfileId(
          data.Profile.name
        );
        // const pattern = /^(route [1-9][0-9]?[0-9]?[0-9]?)$/;

        const legacyRoutes = availableProfileId === -1;

        if (legacyRoutes) {
          const availableProfileByVehicleType =
            this.profileService.getAvailableProfileByVehicleType(
              data.Profile.vehicleType
            );
          if (availableProfileByVehicleType) {
            data.Profile.name = availableProfileByVehicleType.name;
          }

          const dataValue: any = { tripData: { dataValue: data } };
          const modal = this.modalService.show(
            OpenLegacyRouteComponent,
            createModalOptions(dataValue)
          );

          modal.content.drawRouteEvent.subscribe((tripData: Trip) => {
            //here for legacy routes
            this.routeService.drawSavedRoute(tripData, legacyRoutes);
            this.showOldVersionAlert(tripData);
          });
        } else {
          this.routeService.drawSavedRoute(data, legacyRoutes);
          this.showOldVersionAlert(data);
        }
      }
    );
    this.subscriptionManager.manage =
      modalRef.content.deleteRouteCancelEvent.subscribe(() => {
        this.showSavedRoute();
      });
  }
  showOldVersionAlert(data: Trip) {
    if (
      data.Profile?.dataVersion.toUpperCase() < 'PCM28' &&
      data.Profile?.dataVersion.toUpperCase() !== 'CURRENT' &&
      data.Profile?.dataVersion.toUpperCase() !== 'PCM_NA' &&
      data.Profile?.dataVersion.toUpperCase() !== 'PCM_EU' &&
      data.Profile?.dataVersion !== '' //checking empty condition as some saved routes in EU Region has dataversion as empty
    ) {
      const initialState = {
        title: 'Older PC*MILER Versions',
        list: [
          'You may encounter errors and limitations when using PC*MILER v27 and earlier, which are inherit to those versions. These issues are generally minor but for best compatability and stability consider using the most recent version of PC*MILER.',
        ],
        actionButtonText: 'Okay, Got it!',
        btnClass: 'btn btn-primary',
        okOnly: true,
        closeOnly: true,
      };

      const dialogRef = this.modalService.show(ModalboxComponent, {
        initialState,
        ignoreBackdropClick: true,
        keyboard: false,
        animated: true,
        class: 'modal-dialog-centered',
      });
    }
  }
}
